import { useNavigate } from "react-router-dom";
import { useCreateArticle } from "@/hooks/useWriter";
import { ArticleEditor } from "@/components/writer/ArticleEditor";
import { useLocalDraft } from "@/hooks/useLocalDraft";

const DRAFT_KEY = "x402-draft-new";

export function NewArticlePage() {
  const navigate = useNavigate();
  const createMutation = useCreateArticle();
  const draft = useLocalDraft(DRAFT_KEY);

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-2xl font-display font-bold mb-6">New Article</h1>
      <ArticleEditor
        draftKey={DRAFT_KEY}
        onSubmit={(data) => {
          createMutation.mutate(data, {
            onSuccess: () => {
              draft.clear();
              navigate("/writer/articles");
            },
          });
        }}
        loading={createMutation.isPending}
      />
    </div>
  );
}
